import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { ApiVisa, } from '../../shared/api-visa.model';
import { StockAdjustmentImportFileContainerModel } from '../../../../../../models/aggregates/erp/inventory-transaction/stock-adjustment-import-file-container.model';

@Injectable({ providedIn: 'root' })

export class StockAdjustmentImportFileService extends BaseApiTemplateService<StockAdjustmentImportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/backoffice-ep';
    this.httpClient = http;
  }

  async sampleCommaCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
        .get(CSV_URL, { headers, responseType: 'blob' })
        .toPromise();
    return fileBlob;
}

  async samplePipeCSV(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template-pipe';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

}
